"use client";

import { useState } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import InvoiceForm from "@/components/invoice-form";
import PdfPreview from "@/components/pdf-preview";
import { defaultInvoiceData } from "@/lib/invoice-types";
import type { InvoiceData } from "@/lib/invoice-types";

export default function Home() {
  const [data, setData] = useState<InvoiceData>(defaultInvoiceData);

  return (
    <div className="h-screen flex flex-col">
      <header className="border-b px-6 py-1 flex items-center justify-between shrink-0">
        <h1 className="text-xs font-medium">FAKTUROR</h1>
      </header>

      <div className="flex-1 flex min-h-0">
        <div className="w-[440px] shrink-0 border-r">
          <ScrollArea className="h-full">
            <div className="p-5">
              <InvoiceForm data={data} onChange={setData} />
            </div>
          </ScrollArea>
        </div>

        <div className="flex-1 p-5 min-w-0">
          <PdfPreview data={data} />
        </div>
      </div>
    </div>
  );
}
